import { createPlayer, ListPlayer, KeySystem, } from '@js-sdk/playback';
import { ManifestFormat } from './enums/manifest_format';
import { HarmonyStreamer } from './_internal/streamer';
import { TrackPlaybackServiceClient } from './_internal/tp_service/client';
import { TrackPlayerServiceContext } from './_internal/tp_service/context';
export { HarmonyStreamer };
export function createStreamerForClient(client, options = {}) {
    const sdkId = client.getSDKId();
    const transport = client.getPublicTransport();
    const logger = client.getLogger();
    const descriptor = client.getDeviceDescriptor();
    // FIXME: use TypeScript Nullish Coalescing
    const initialVolume = 'initialVolume' in options && options.initialVolume !== undefined
        ? options.initialVolume
        : 1;
    const createPlayerOptions = Object.assign(Object.assign({}, options), { transport,
        logger, sdkId: client.getUntaggedSDKId() });
    const playerPromise = createPlayer(createPlayerOptions).then(
    // Unpack the player.
    ({ player }) => player);
    const keySystemConfiguration = playerPromise
        .then((player) => player.getKeySystemInfo())
        .then((keySystemInfo) => {
        return {
            keySystem: keySystemInfo && keySystemInfo.keySystem,
            supportsVideo: !!(keySystemInfo && keySystemInfo.videoFormats.length),
        };
    })
        .catch(() => {
        // Default in case there's an issue with the KeySystem.
        return {
            keySystem: '',
            supportsVideo: false,
        };
    });
    const descriptorPromise = Promise.all([
        descriptor,
        keySystemConfiguration,
    ]).then(([_desc, ksConf]) => {
        // Add external podcasts if podcasts are enabled.
        if (_desc.getCapability('audio_podcasts') &&
            !options.disableExternalFiles) {
            _desc.appendManifestFormat(ManifestFormat.FILE_URLS_EXTERNAL);
        }
        // Add the audio file formats
        if (ksConf.keySystem === KeySystem.FAIRPLAY) {
            _desc.appendManifestFormat(ManifestFormat.FILE_IDS_CBCS);
        }
        else if (ksConf.keySystem === KeySystem.WIDEVINE &&
            !options.preferMultiDRMFormat) {
            _desc.appendManifestFormat(ManifestFormat.FILE_IDS_MP4, ManifestFormat.FILE_IDS_MP4_DUAL);
        }
        else {
            _desc.appendManifestFormat(ManifestFormat.FILE_IDS_MP4_DUAL, ManifestFormat.FILE_IDS_MP4);
        }
        // Add the video file formats, if supported
        if (ksConf.supportsVideo && _desc.getCapability('video_playback')) {
            _desc.prependManifestFormat(ManifestFormat.MANIFEST_IDS_VIDEO);
        }
        return _desc;
    });
    // List Player
    const listPlayer = ListPlayer.create({
        trackPlayer: playerPromise,
    });
    // TP-API Client
    const tpApiClient = TrackPlaybackServiceClient.create({
        initialVolume,
        listPlayer,
        logger,
        transport,
        clientVersion: sdkId,
        descriptor: descriptorPromise,
        endpoint: options.endpoint,
        ListClass: TrackPlayerServiceContext,
    });
    // Set the default for stopOnBackground behaviour. The lack of a MediaSource
    // API is a good giveaway that the platform does not support background
    // execution (because MediaSource requires this to function on the
    // background).
    const stopOnBackground = 'stopOnBackground' in options
        ? options.stopOnBackground
        : typeof MediaSource === 'undefined';
    return new HarmonyStreamer({
        client,
        listPlayer,
        tpApiClient,
        playerPromise,
        initialVolume,
        stopOnBackground,
    });
}
// TODO: Find a way to remove this function
export function of(harmony) {
    // See https://github.com/microsoft/TypeScript/issues/19335
    // eslint-disable-next-line dot-notation
    const streamer = harmony['_streamer'];
    if (!(streamer instanceof HarmonyStreamer)) {
        throw new Error('The harmony instance has an invalid `_streamer`.');
    }
    return streamer;
}
//# sourceMappingURL=streamer.js.map